import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const DutyUnpaidEstimate = (props) => {
  const { cartOrOrder } = props;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { duties } = cartOrOrder;

  if (!duties) {
    return null;
  }

  const dutyUnpaid = duties.filter(
    (duty) => duty.isUnpaidDutyEstimate === true
  );

  return (
    <>
      {dutyUnpaid.map((duty) => (
        <div className="c7-order-summary__item--notes" key={duty.id}>
          <div className="c7-order-summary__title">
            {duty.title} {t('checkout.general.estimate')}
          </div>
          <div className="c7-order-summary__value">
            {currencyFormat(duty.price, currency)}
          </div>
        </div>
      ))}
    </>
  );
};

export default DutyUnpaidEstimate;
